import React from 'react';
import PropTypes from 'prop-types';
import Image from '../../components/Image';
import LockBookmarkImage from '../../components/SubscriptionModule/Lock.svg';
import Button from '../../components/Button';
import './styles.css';

const LockedContentComponent = ({ body, toggleUpgradeFormVisibility }) => (
  <div styleName="content">
    <div>
      <Image src={LockBookmarkImage} aria-hidden="true" styleName="module-premium-lock" />
      <div styleName="intro-paragraph">
        {body}
      </div>
      <Button secondary styleName="upgrade-button" onClick={toggleUpgradeFormVisibility}>Upgrade</Button><br /><br /><br />
    </div>
  </div>
);

LockedContentComponent.propTypes = {
  body: PropTypes.string.isRequired,
  toggleUpgradeFormVisibility: PropTypes.func.isRequired,
};

export default LockedContentComponent;
